// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/dev/api-esterne/applicazioni/1/documentazione.pdf',
    requestBody: null,
    response: 'application/pdf'
  },
  {
    method: 'GET',
    endpoint: '/api/dev/api-esterne/catalogo',
    requestBody: null,
    response: '{"success":true,"baseUrl":"https://back-bop.pianinvest.it","data":[{"codice":"nominativi.lettura","etichetta":"Nominativi (lettura)","gruppo":"Anagrafiche","descrizione":"...","endpoints":[{"metodo":"GET","path":"/api/ext/nominativi","titolo":"Lista nominativi","descrizione":"...","parametri":[],"risposta":{"tipo":"lista","campi":[]},"errori":[],"esempioRisposta":{}}]}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/dev/api-esterne/applicazioni?societaId=1',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"societaId":1,"codice":"crm","nome":"CRM","descrizione":null,"referente":null,"attiva":true,"note":null,"apiAbilitate":["nominativi.lettura"],"chiavi":[],"chiaviAttive":0}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/dev/api-esterne/applicazioni/1',
    requestBody: null,
    response: '{"success":true,"data":{"id":1,"codice":"crm","nome":"CRM","attiva":true,"apiAbilitate":["nominativi.lettura"],"chiavi":[{"id":1,"nome":"Prod","prefisso":"bop_a1b2c3d4","stato":"ATTIVA","statoEffettivo":"ATTIVA","scadenzaAt":null,"ultimoUtilizzoAt":null,"numeroChiamate":0}],"chiaviAttive":1,"ultimeChiamate":[]}}'
  },
  {
    method: 'POST',
    endpoint: '/api/dev/api-esterne/applicazioni',
    requestBody: '{"societaId":1,"codice":"crm","nome":"CRM","descrizione":"","referente":"","note":""}',
    response: '{"success":true,"data":{"id":1,"codice":"crm","nome":"CRM","apiAbilitate":[],"chiavi":[],"chiaviAttive":0}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/dev/api-esterne/applicazioni/1',
    requestBody: '{"nome":"CRM","descrizione":"","referente":"","note":""}',
    response: '{"success":true,"data":{"id":1,"nome":"CRM","attiva":true}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/dev/api-esterne/applicazioni/1',
    requestBody: '{"attiva":false}',
    response: '{"success":true,"data":{"id":1,"attiva":false}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/dev/api-esterne/applicazioni/1/api',
    requestBody: '{"codici":["nominativi.lettura"]}',
    response: '{"success":true,"data":{"id":1,"apiAbilitate":["nominativi.lettura"]}}'
  },
  {
    method: 'POST',
    endpoint: '/api/dev/api-esterne/applicazioni/1/chiavi',
    requestBody: '{"nome":"Produzione","scadenzaAt":null}',
    response: '{"success":true,"data":{"id":1,"nome":"Produzione","prefisso":"bop_a1b2c3d4","stato":"ATTIVA","statoEffettivo":"ATTIVA","chiave":"bop_...40hex"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/dev/api-esterne/applicazioni/1/chiavi/1/revoca',
    requestBody: null,
    response: '{"success":true,"data":{"id":1,"stato":"REVOCATA","statoEffettivo":"REVOCATA"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/dev/api-esterne/applicazioni/1/log?limit=20',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"createdAt":"2026-09-15T10:00:00.000Z","prefisso":"bop_a1b2c3d4","codiceApi":"nominativi.lettura","metodo":"GET","path":"/api/ext/nominativi","statusCode":200,"durataMs":12,"ip":"1.2.3.4","esito":"OK","errore":null}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
